import styled from "styled-components";

const pageviewsChartWrapper = styled.div`
  .page-view-chart-widget-card {
    background-color: white;
    height: 100%;
    .header {
      padding: 24px;
      letter-spacing: 0.02em;
    }

    .analytics {
      padding: 0 24px 15px 24px;
    }
  }
`;

export default pageviewsChartWrapper;
